import { buildModelManager } from "../builder.js";
const DefaultPaymentAllocationSelection = {
  __typename: true,
  id: true,
  allocatedAt: true,
  amount: true,
  createdAt: true,
  deletedAt: true,
  invoiceId: true,
  paymentId: true,
  paymentMilestoneId: true,
  profileId: true,
  updatedAt: true
};
const modelApiIdentifier = "paymentAllocation";
const pluralModelApiIdentifier = "paymentAllocations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPaymentAllocationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPaymentAllocationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPaymentAllocationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPaymentAllocationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPaymentAllocationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPaymentAllocationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPaymentAllocationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPaymentAllocation",
    operationReturnType: "CreatePaymentAllocation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      paymentAllocation: { required: false, type: "CreatePaymentAllocationInput" },
      payment: { required: false, type: "String" },
      invoice: { required: false, type: "String" },
      paymentMilestone: { required: false, type: "String" },
      amount: { required: false, type: "Float" },
      allocatedAt: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [
      "payment",
      "invoice",
      "paymentMilestone",
      "amount",
      "allocatedAt"
    ],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPaymentAllocationSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePaymentAllocations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreatePaymentAllocationsInput!]" }
    },
    paramOnlyVariables: [
      "payment",
      "invoice",
      "paymentMilestone",
      "amount",
      "allocatedAt"
    ],
    defaultSelection: DefaultPaymentAllocationSelection
  },
  {
    type: "action",
    operationName: "deletePaymentAllocation",
    operationReturnType: "DeletePaymentAllocation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeletePaymentAllocations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restorePaymentAllocation",
    operationReturnType: "RestorePaymentAllocation",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      paymentAllocation: { required: false, type: "RestorePaymentAllocationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPaymentAllocationSelection
  },
  {
    type: "action",
    operationName: "bulkRestorePaymentAllocations",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestorePaymentAllocationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPaymentAllocationSelection
  },
  {
    type: "action",
    operationName: "upsertPaymentAllocation",
    operationReturnType: "UpsertPaymentAllocation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      paymentAllocation: { required: false, type: "UpsertPaymentAllocationInput" },
      payment: { required: false, type: "String" },
      invoice: { required: false, type: "String" },
      paymentMilestone: { required: false, type: "String" },
      amount: { required: false, type: "Float" },
      allocatedAt: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [
      "on",
      "payment",
      "invoice",
      "paymentMilestone",
      "amount",
      "allocatedAt"
    ],
    hasReturnType: {
      "... on CreatePaymentAllocationResult": { hasReturnType: false },
      "... on RestorePaymentAllocationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPaymentAllocationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPaymentAllocations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertPaymentAllocationsInput!]" }
    },
    paramOnlyVariables: [
      "on",
      "payment",
      "invoice",
      "paymentMilestone",
      "amount",
      "allocatedAt"
    ],
    defaultSelection: DefaultPaymentAllocationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "paymentAllocationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PaymentAllocationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPaymentAllocationSelection,
  operations
);
export {
  DefaultPaymentAllocationSelection,
  PaymentAllocationManager
};
//# sourceMappingURL=PaymentAllocation.js.map
